import React, { useState, useEffect } from 'react';
import './App.css';
import { css } from "@emotion/react";
import '@material-ui/icons'; 
import Header from './components/Header';
import Navbar from './components/Navbar';
import ScaleLoader from "react-spinners/ScaleLoader";
import Content1 from "./components/Content1";
import Content2 from "./components/Content2";
import Content3 from "./components/Content3";
import Footer from "./components/Footer";
import Main from "./components/Main";

const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

function App() {
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#FF1215");
    useEffect(() => {
      setTimeout(() => setLoading(false), 2660)
    }, []);
  return (
    <><div className="sweet-loading">
      <ScaleLoader color={color} loading={loading} css={override} height={15} width={2} />
    </div><div className="App">
        <Navbar />
        <Header />
        <Main/>
        <Content1 />
        <Content2 />
        <Content3 />
        <Footer />
      </div></>
  );
}


export default App;
